<template>
  <form class="p-3" @submit.prevent="validar">
    <div class="row">
      <div class="form-group col-md-6 col-12">
        <label><i class="fa fa-asterisk text-danger"></i>Tipo de activo</label>
        <combo-box
            v-model="datos.tipoActivo"
            :valid="errors.has('tipo de activo')"
            :opciones="lista"
            name="tipo de activo"
            v-validate="{required:true,obj:true}"
        ></combo-box>
        <span class="form-text text-danger">{{ errors.first("tipo de activo") }}</span>
      </div>
      <template v-if="cambio">
        <template v-for="i in 3">
          <div class="form-group col-md-6 col-12" :key="i" v-if="validarFieldCombo(i)">
            <label><i class="fa fa-asterisk text-danger"></i>{{ buscarLabel(i) }}</label>
            <combo-box-tag
                v-model="datos.secciones[i]"
                :valid="errors.has(buscarLabel(i))"
                :opciones="arreglo[activoSelected.secciones[i-1].datos]"
                :name="buscarLabel(i)"
                v-validate="{required:true}"
            ></combo-box-tag>
            <span class="form-text text-danger">{{ errors.first(buscarLabel(i)) }}</span>
          </div>
          <div class="form-group col-md-6 col-12" :key="i" v-if="validarField(i)">
            <label :for="buscarLabel(i)"><i class="fa fa-asterisk text-danger"></i>{{ buscarLabel(i) }}</label>
            <input
                type="text"
                class="form-control"
                :class="errors.has(buscarLabel(i)) && 'is-invalid'"
                v-model="datos.secciones[i]"
                :name="buscarLabel(i)"
                :id="buscarLabel(i)"
                v-validate="{required:true}"
            >
            <span class="form-text text-danger">{{ errors.first(buscarLabel(i)) }}</span>
          </div>
        </template>
        <div class="form-group col-md-6 col-12">
          <label for="valor"><i class="fa fa-asterisk text-danger"></i>Valor del activo</label>
          <input
              type="number"
              class="form-control"
              :class="errors.has('valor') && 'is-invalid'"
              v-model="datos.valor"
              name="valor"
              id="valor"
              v-validate="{required:true,decimal:2,min_value:1}"
              min="1" step="any"
          >
          <span class="form-text text-danger">{{ errors.first("valor") }}</span>
        </div>
      </template>
      <div class="col-12 col-md-12 p-1">
        <div class="col-12 col-md-4 p-1">
          <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
        </div>
      </div>
    </div>
    <div class="table-responsive pt-2">
      <table class="table table-sm table-striped">
        <thead>
        <tr>
          <th>Tipo de activo</th>
          <th>Referencia</th>
          <th>Descripción</th>
          <th>Detalle</th>
          <th class="text-right">Valor</th>
          <th class="text-center">Acción</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(i,ii) in registros" :key="ii" class="animated fadeInDown">
          <th scope="row">{{ lista.find(x => x.id === i[dtoEscritura.tipoId]).dt1 }}</th>
          <td>{{ i[dtoEscritura.referencia] }}</td>
          <td>{{ i[dtoEscritura.descripcion] }}</td>
          <td>{{ i[dtoEscritura.detalle] }}</td>
          <td class="text-right precio-syb">{{ puntos(i[dtoEscritura.valor]) }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii)" title="Eliminar">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr v-if="registros.length">
          <th colspan="4" class="text-right">Total:</th>
          <td class="text-right precio-syb">{{ puntos(suma(registros)) }}</td>
          <td></td>
        </tr>
        <tr v-else>
          <td colspan="6" class="text-center text-muted">
            No hay elementos agregados<br>
            <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </form>
</template>

<script>
import comboBox from "../comboBox";
import comboBoxTag from "../comboBoxTag";
import constantes from "../../constantes";

export default {
  name: "activos",
  data: () => ({
    datos: {
      tipoActivo: {id: null},
      secciones: {
        1: null,
        2: null,
        3: null,
      },
      valor: null,
    },
    arreglo: {
      lstInstitucion: [],
      lstTipoInmueble: [],
      lstMarca: [],
      lstModelo: [],
      lstAnio: []
    },
    cambio: true,
    registros: [],
    activoSelected: undefined,
    dtoLectura: {
      tipoId: 'ndt2',
      referencia: 'dt1',
      descripcion: 'dt2',
      detalle: 'dt3',
      id: 'id',
      valor: 'ndt1',
    },
    dtoEscritura: {
      tipoId: 'ndt2',
      referencia: 'dt1',
      descripcion: 'dt2',
      detalle: 'dt3',
      id: 'id',
      valor: 'ndt1',
    },
    validarEntrada:'ndt1',
  }),
  watch: {
    registros: function (val) {
      this.$emit("input", val);
    },
    "datos.tipoActivo.id": function () {
      this.datos.valor = null;
      this.datos.secciones = {
        1: null,
        2: null,
        3: null
      };
      this.trigger();
      this.activoSelected = constantes.Constantes.tiposActivos.find(a => a.id === this.datos.tipoActivo.id);
    },
    "lstInstitucion": function (v) {
      this.arreglo.lstInstitucion = v;
    },
    "lstTipoInmueble": function (v) {
      this.arreglo.lstTipoInmueble = v;
    },
    "lstMarca": function (v) {
      this.arreglo.lstMarca = v
    },
    "datos.secciones.1": function (v) {
      if (this.activoSelected && this.activoSelected.id === 5) {
        this.$emit('marca', v.id);
      }
    },
    "lstModelo": function (v) {
      this.arreglo.lstModelo = v;
    },
    "previos": function () {
      this.preCargar();
    },
    sync: function () {
      this.preCargar();
    }

  },
  props: {
    sync: {
      type: Boolean,
      default: false,
    },
    previos: {
      type: Array,
      default: function () {
        return [];
      },
    },
    lista: {
      type: Array,
    },
    lstInstitucion: {
      type: Array,
      required: true
    },
    lstTipoInmueble: {
      type: Array,
      required: true
    },
    lstMarca: {
      type: Array,
      required: true
    },
    lstModelo: {
      type: Array,
      required: true
    }
  },
  components: {
    comboBox,
    comboBoxTag,
  },
  methods: {
    puntos: (numero) => constantes.funciones.puntoMilesDecimal(parseFloat(numero)),
    suma: function (lista) {
      return constantes.funciones.sumar3(this.dtoEscritura.valor, lista);
    },
    eliminar: function (indice) {
      this.registros.splice(indice, 1);
    },
    trigger: function () {
      this.cambio = false;
      setTimeout(() => {
        this.cambio = true;
      }, 2);
    },
    buscarLabel: function (indice) {
      let label = "";
      let seccion = constantes.Constantes.tiposActivos.find(a => a.id === this.datos.tipoActivo.id).secciones[indice - 1];
      if (seccion.tipo !== constantes.Constantes.enumeraciones.tipoCampo.noAplica) {
        label = seccion.label
      }
      return label;
    },
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const referencia = this.datos.secciones["1"];
          const descripcion = this.datos.secciones["2"];
          const detalle = this.datos.secciones["3"];
          const datos = {
            referencia: referencia ? referencia.dt1 ? referencia.dt1 : referencia.toUpperCase() : null,
            descripcion: descripcion ? descripcion.dt1 ? descripcion.dt1 : descripcion.toUpperCase() : null,
            detalle: detalle ? detalle.dt1 ? detalle.dt1 : detalle.toUpperCase() : null,
            valor: this.datos.valor,
            tipoId: this.datos.tipoActivo.id,
          };
          let aux = {};
          for (const [key] of Object.entries(this.dtoEscritura)) {
            aux[this.dtoEscritura[key]]=datos[key];
          }
          this.registros.push(aux);
          this.datos = {
            tipoActivo: {id: null},
            secciones: {
              1: null,
              2: null,
              3: null,
            },
            valor: null
          };
          this.activoSelected = undefined;
          this.trigger();
        } else {
          this.$toast.show(`Completa el formulario Activos`);
        }
      });
    },
    validarField(seccion) {
      return this.activoSelected ? this.activoSelected.secciones[seccion - 1].tipo === constantes.Constantes.enumeraciones.tipoCampo.texto : false;
    },
    validarFieldCombo(seccion) {
      return this.activoSelected ? this.activoSelected.secciones[seccion - 1].tipo === constantes.Constantes.enumeraciones.tipoCampo.combo : false;
    },
    getNumbersDto: function (start, stop) {
      let list = [];
      for (let i = start; i <= stop; i++) {
        list.push(
            {
              id: i,
              dt1: i
            });
      }
      return list;
    },
    getAnios() {
      const fecha = new Date();
      const anioActual = fecha.getFullYear();
      this.arreglo.lstAnio = [...this.getNumbersDto(anioActual-50, anioActual)];
    },
    preCargar: function () {
      this.previos.map(i => {
        let aux = {};
        for (const [key, value] of Object.entries(this.dtoLectura)) {
          aux[this.dtoEscritura[key]]=i[value];
        }
        if(aux[this.validarEntrada]>0){
          this.registros.push(aux);
        }
      });
    }
  },
  created() {
    this.getAnios();
  },
}
</script>

<style scoped>

</style>
